export default __webpack_public_path__ + "static/aap-logo~CMzjEpqK-b06164026086426aec695e3fe5b91304.png";